import { render, staticRenderFns } from "./StudentTraining.vue?vue&type=template&id=2d3823bc&scoped=true"
import script from "./StudentTraining.vue?vue&type=script&lang=js"
export * from "./StudentTraining.vue?vue&type=script&lang=js"
import style0 from "./StudentTraining.vue?vue&type=style&index=0&id=2d3823bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3823bc",
  null
  
)

export default component.exports